import {Asset} from "../entities/Asset";
import {CommandManager} from "../libs/CommandManager";
import {CommandBase} from "./CommandBase";

export class CommandClearAlarmsCtrl extends CommandBase{
    selectedItems:any[];
    commandEnabled:boolean = false;
    static $inject = ['CommandManager'];
    constructor(commandManager:CommandManager) {
        super(commandManager);
    }
    getCommandText(asset:Asset):string{
        return asset.vTagID;
    }
    getCommandType():string{
        return "Clear Alarms";
    }
}

export class CommandClearAlarmsDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdclearalarms.html').default;
    scope = {
        selectedItems : "=",
        commandEnabled : "=",
    };
    constructor() {
    }
    controller = CommandClearAlarmsCtrl;
    controllerAs = "vm";
    link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any): void {
        controller.commandEnabled = scope.commandEnabled;
        scope.$watch(()=>scope.selectedItems.length, (newVal:any)=> {
            controller.selectedItems = scope.selectedItems;
        });
        scope.$watch(()=>scope.commandEnabled, (newVal:any)=> {
            controller.commandEnabled = scope.commandEnabled;
        });
    }
    static factory():ng.IDirectiveFactory {
        var directive = () => {
            return new CommandClearAlarmsDirective();
        }
        return directive;
    }
}
